// leave it as a note shows usage for createMatchSelector
// import { createMatchSelector } from 'connected-react-router'
// import routes from '../routes'

// const proposalRoute = _.find(routes, {pageKey: 'Proposal'})
// const proposalMatchSelector = createMatchSelector(proposalRoute.path)

const communicator = store => next => action => {
  switch (action.type) {
    case '@@redux-form/CHANGE': {
      break
    }

    default:
      break
  }

  return next(action)
}

export default communicator
